/* eslint-disable max-lines */
import { TIdToPageMap } from 'models/common.model'
import { ID_TO_PAGE_MAP_WOOFZ22V3 } from 'nove8/cohorts/woofz22_v3/constants/pages-map'
import { ID_TO_PAGE_MAP_WOOFZ22V4 } from 'nove8/cohorts/woofz22_v4/constants/pages-map'
import { ID_TO_PAGE_MAP_WOOFZ22V4_WT } from 'nove8/cohorts/woofz22_v4_wt/constants/pages-map'
import { ID_TO_PAGE_MAP_WOOFZ22V4_BG } from 'nove8/cohorts/woofz22_v4_bg/constants/pages-map'
import { ID_TO_PAGE_MAP_WOOFZ22V4L } from 'nove8/cohorts/woofz22_v4l/constants/pages-map'
import { ID_TO_PAGE_MAP_WOOFZ22V4T } from 'nove8/cohorts/woofz22_v4t/constants/pages-map'
import { ID_TO_PAGE_MAP_WOOFZ22V9 } from 'nove8/cohorts/woofz22_v9/constants/pages-map'
import { ID_TO_PAGE_MAP_WOOFZ_COACHING } from 'nove8/cohorts/woofz_coaching/constants/pages-map'
import { ID_TO_PAGE_MAP_WOOFZ_EASTER_65 } from 'nove8/cohorts/woofz_easter/woofz_easter_65/constants/pages-map'
import { ID_TO_PAGE_MAP_WOOFZ_EASTER_70 } from 'nove8/cohorts/woofz_easter/woofz_easter_70/constants/pages-map'
import { ID_TO_PAGE_MAP_WOOFZ_EASTER_75 } from 'nove8/cohorts/woofz_easter/woofz_easter_75/constants/pages-map'
import { ID_TO_PAGE_MAP_WOOFZ_EASTER_80 } from 'nove8/cohorts/woofz_easter/woofz_easter_80/constants/pages-map'
import { ID_TO_PAGE_MAP_WOOFZ_ESA } from 'nove8/cohorts/woofz_esa/constants/pages-map'
import { ID_TO_PAGE_MAP_WOOFZ_HLWN_65 } from 'nove8/cohorts/woofz_hlwn/woofz_hlwn_65/constants/pages-map'
import { ID_TO_PAGE_MAP_WOOFZ_HLWN_70 } from 'nove8/cohorts/woofz_hlwn/woofz_hlwn_70/constants/pages-map'
import { ID_TO_PAGE_MAP_WOOFZ_HLWN_75 } from 'nove8/cohorts/woofz_hlwn/woofz_hlwn_75/constants/pages-map'
import { ID_TO_PAGE_MAP_WOOFZ_HLWN_80 } from 'nove8/cohorts/woofz_hlwn/woofz_hlwn_80/constants/pages-map'
import { ID_TO_PAGE_MAP_WOOFZ_INVX } from 'nove8/cohorts/woofz_invx/constants/pages-map'
import { ID_TO_PAGE_MAP_WOOFZ_K9 } from 'nove8/cohorts/woofz_k9/constants/pages-map'
import { ID_TO_PAGE_MAP_WOOFZ_K9_BL } from 'nove8/cohorts/woofz_k9_bl/constants/pages-map'
import { ID_TO_PAGE_MAP_WOOFZ_K9_BL_BG } from 'nove8/cohorts/woofz_k9_bl_bg/constants/pages-map'
import { ID_TO_PAGE_MAP_WOOFZ_K9_DRSL } from 'nove8/cohorts/woofz_k9_drsl/constants/pages-map'
import { ID_TO_PAGE_MAP_WOOFZ_LOVE } from 'nove8/cohorts/woofz_love/constants/pages-map'
import { ID_TO_PAGE_MAP_WOOFZ_LOVE_BL } from 'nove8/cohorts/woofz_love_bl/constants/pages-map'
import { ID_TO_PAGE_MAP_WOOFZ_NDD_65 } from 'nove8/cohorts/woofz_ndd/woofz_ndd_65/constants/pages-map'
import { ID_TO_PAGE_MAP_WOOFZ_NDD_70 } from 'nove8/cohorts/woofz_ndd/woofz_ndd_70/constants/pages-map'
import { ID_TO_PAGE_MAP_WOOFZ_NDD_75 } from 'nove8/cohorts/woofz_ndd/woofz_ndd_75/constants/pages-map'
import { ID_TO_PAGE_MAP_WOOFZ_NDD_80 } from 'nove8/cohorts/woofz_ndd/woofz_ndd_80/constants/pages-map'
import { ID_TO_PAGE_MAP_WOOFZ_NDD } from 'nove8/cohorts/woofz_ndd/woofz_ndd_cohort/constants/pages-map'
import { ID_TO_PAGE_MAP_WOOFZ_NPDAY_65 } from 'nove8/cohorts/woofz_npday/woofz_npday_65/constants/pages-map'
import { ID_TO_PAGE_MAP_WOOFZ_NPDAY_70 } from 'nove8/cohorts/woofz_npday/woofz_npday_70/constants/pages-map'
import { ID_TO_PAGE_MAP_WOOFZ_NPDAY_75 } from 'nove8/cohorts/woofz_npday/woofz_npday_75/constants/pages-map'
import { ID_TO_PAGE_MAP_WOOFZ_NPDAY_80 } from 'nove8/cohorts/woofz_npday/woofz_npday_80/constants/pages-map'
import { ID_TO_PAGE_MAP_WOOFZ_NRDAY_65 } from 'nove8/cohorts/woofz_nrday/woofz_nrday_65/constants/pages-map'
import { ID_TO_PAGE_MAP_WOOFZ_NRDAY_70 } from 'nove8/cohorts/woofz_nrday/woofz_nrday_70/constants/pages-map'
import { ID_TO_PAGE_MAP_WOOFZ_NRDAY_75 } from 'nove8/cohorts/woofz_nrday/woofz_nrday_75/constants/pages-map'
import { ID_TO_PAGE_MAP_WOOFZ_NRDAY_80 } from 'nove8/cohorts/woofz_nrday/woofz_nrday_80/constants/pages-map'
import { ID_TO_PAGE_MAP_WOOFZ_OFFER1_65 } from 'nove8/cohorts/woofz_offer/woofz_offer1_65/constants/pages-map'
import { ID_TO_PAGE_MAP_WOOFZ_OFFER1_70 } from 'nove8/cohorts/woofz_offer/woofz_offer1_70/constants/pages-map'
import { ID_TO_PAGE_MAP_WOOFZ_OFFER1_75 } from 'nove8/cohorts/woofz_offer/woofz_offer1_75/constants/pages-map'
import { ID_TO_PAGE_MAP_WOOFZ_OFFER1_80 } from 'nove8/cohorts/woofz_offer/woofz_offer1_80/constants/pages-map'
import { ID_TO_PAGE_MAP_WOOFZ_OFFER2_70 } from 'nove8/cohorts/woofz_offer/woofz_offer2_70/constants/pages-map'
import { ID_TO_PAGE_MAP_WOOFZ_OFFER2_75 } from 'nove8/cohorts/woofz_offer/woofz_offer2_75/constants/pages-map'
import { ID_TO_PAGE_MAP_WOOFZ_PAW_NUP } from 'nove8/cohorts/woofz_paw_nup/constants/pages-map'
import { ID_TO_PAGE_MAP_WOOFZPN } from 'nove8/cohorts/woofz_pn/constants/pages-map'
import { ID_TO_PAGE_MAP_WOOFZ_PPDAY_65 } from 'nove8/cohorts/woofz_ppday/woofz_ppday_65/constants/pages-map'
import { ID_TO_PAGE_MAP_WOOFZ_PPDAY_70 } from 'nove8/cohorts/woofz_ppday/woofz_ppday_70/constants/pages-map'
import { ID_TO_PAGE_MAP_WOOFZ_PPDAY_75 } from 'nove8/cohorts/woofz_ppday/woofz_ppday_75/constants/pages-map'
import { ID_TO_PAGE_MAP_WOOFZ_PPDAY_80 } from 'nove8/cohorts/woofz_ppday/woofz_ppday_80/constants/pages-map'
import { ID_TO_PAGE_MAP_WOOFZ_PPP } from 'nove8/cohorts/woofz_ppp/constants/pages-map'
import { ID_TO_PAGE_MAP_WOOFZ_PPP_BL } from 'nove8/cohorts/woofz_ppp_bl/constants/pages-map'
import { ID_TO_PAGE_MAP_WOOFZ_PPP_WOOFY } from 'nove8/cohorts/woofz_ppp_woofy/constants/pages-map'
import { ID_TO_PAGE_MAP_WOOFZ_PT1 } from 'nove8/cohorts/woofz_pt1/constants/pages-map'
import { ID_TO_PAGE_MAP_WOOFZ_PT1_BG } from 'nove8/cohorts/woofz_pt1_bg/constants/pages-map'
import { ID_TO_PAGE_MAP_WOOFZ_PUP } from 'nove8/cohorts/woofz_pup/constants/pages-map'
import { ID_TO_PAGE_MAP_WOOFZ_PUP_BL } from 'nove8/cohorts/woofz_pup_bl/constants/pages-map'
import { ID_TO_PAGE_MAP_WOOFZ_PUP_DRSL } from 'nove8/cohorts/woofz_pup_drsl/constants/pages-map'
import { ID_TO_PAGE_MAP_WOOFZ_PUP_WT } from 'nove8/cohorts/woofz_pup_wt/constants/pages-map'
import { ID_TO_PAGE_MAP_WOOFZ_RFND3 } from 'nove8/cohorts/woofz_rfnd3/constants/pages-map'
import { ID_TO_PAGE_MAP_WOOFZ_RFND3_ND } from 'nove8/cohorts/woofz_rfnd3_nd/constants/pages-map'
import { ID_TO_PAGE_MAP_WOOFZ_RT } from 'nove8/cohorts/woofz_rt/constants/pages-map'
import { ID_TO_PAGE_MAP_WOOFZ_S1_6_12 } from 'nove8/cohorts/woofz_s/woofz_s1_6_12/constants/pages-map'
import { ID_TO_PAGE_MAP_WOOFZ_S2_6_12 } from 'nove8/cohorts/woofz_s/woofz_s2_6_12/constants/pages-map'
import { ID_TO_PAGE_MAP_WOOFZ_S3_6_12 } from 'nove8/cohorts/woofz_s/woofz_s3_6_12/constants/pages-map'
import { ID_TO_PAGE_MAP_WOOFZ_SMD } from 'nove8/cohorts/woofz_smd/constants/pages-map'
import { ID_TO_PAGE_MAP_WOOFZ_SMD_BL } from 'nove8/cohorts/woofz_smd_bl/constants/pages-map'
import { ID_TO_PAGE_MAP_WOOFZ_SUB_CNLD_70 } from 'nove8/cohorts/woofz_sub_cnld_70/constants/pages-map'
import { ID_TO_PAGE_MAP_WOOFZ_VC6 } from 'nove8/cohorts/woofz_vc6/constants/pages-map'
import { ID_TO_PAGE_MAP_WOOFZ_VDAY_65 } from 'nove8/cohorts/woofz_vday/woofz_vday_65/constants/pages-map'
import { ID_TO_PAGE_MAP_WOOFZ_VDAY_70 } from 'nove8/cohorts/woofz_vday/woofz_vday_70/constants/pages-map'
import { ID_TO_PAGE_MAP_WOOFZ_VDAY_75 } from 'nove8/cohorts/woofz_vday/woofz_vday_75/constants/pages-map'
import { ID_TO_PAGE_MAP_WOOFZ_VDAY_80 } from 'nove8/cohorts/woofz_vday/woofz_vday_80/constants/pages-map'
import { ID_TO_PAGE_MAP_WOOFZ_VGS } from 'nove8/cohorts/woofz_vgs/constants/pages-map'
import { ID_TO_PAGE_MAP_WOOFZ_WA1 } from 'nove8/cohorts/woofz_wa1/constants/pages-map'
import { ID_TO_PAGE_MAP_WOOFZ_WOOFY } from 'nove8/cohorts/woofz_woofy1/constants/pages-map'
import { ID_TO_PAGE_MAP_WOOFZWS2 } from 'nove8/cohorts/woofz_ws2/constants/pages-map'
import { ID_TO_PAGE_MAP_WOOFZ_XMAS_65 } from 'nove8/cohorts/woofz_xmas/woofz_xmas_65/constants/pages-map'
import { ID_TO_PAGE_MAP_WOOFZ_XMAS_70 } from 'nove8/cohorts/woofz_xmas/woofz_xmas_70/constants/pages-map'
import { ID_TO_PAGE_MAP_WOOFZ_XMAS_80 } from 'nove8/cohorts/woofz_xmas/woofz_xmas_80/constants/pages-map'

export const ID_TO_PAGE_MAP: TIdToPageMap = {
  ...ID_TO_PAGE_MAP_WOOFZ22V9,
  ...ID_TO_PAGE_MAP_WOOFZ22V4L,
  ...ID_TO_PAGE_MAP_WOOFZ22V4_WT,
  ...ID_TO_PAGE_MAP_WOOFZPN,
  ...ID_TO_PAGE_MAP_WOOFZ_ESA,
  ...ID_TO_PAGE_MAP_WOOFZ_LOVE,
  ...ID_TO_PAGE_MAP_WOOFZ_LOVE_BL,
  ...ID_TO_PAGE_MAP_WOOFZWS2,
  ...ID_TO_PAGE_MAP_WOOFZ_VGS,
  ...ID_TO_PAGE_MAP_WOOFZ_RFND3_ND,
  ...ID_TO_PAGE_MAP_WOOFZ_VC6,
  ...ID_TO_PAGE_MAP_WOOFZ22V3,
  ...ID_TO_PAGE_MAP_WOOFZ_PT1,
  ...ID_TO_PAGE_MAP_WOOFZ22V4,
  ...ID_TO_PAGE_MAP_WOOFZ_RFND3,
  ...ID_TO_PAGE_MAP_WOOFZ_PPP,
  ...ID_TO_PAGE_MAP_WOOFZ22V4T,
  ...ID_TO_PAGE_MAP_WOOFZ_PPP_BL,
  ...ID_TO_PAGE_MAP_WOOFZ_PPP_WOOFY,
  ...ID_TO_PAGE_MAP_WOOFZ_EASTER_65,
  ...ID_TO_PAGE_MAP_WOOFZ_EASTER_70,
  ...ID_TO_PAGE_MAP_WOOFZ_EASTER_75,
  ...ID_TO_PAGE_MAP_WOOFZ_EASTER_80,
  ...ID_TO_PAGE_MAP_WOOFZ_S1_6_12,
  ...ID_TO_PAGE_MAP_WOOFZ_S2_6_12,
  ...ID_TO_PAGE_MAP_WOOFZ_S3_6_12,
  ...ID_TO_PAGE_MAP_WOOFZ_NPDAY_65,
  ...ID_TO_PAGE_MAP_WOOFZ_NPDAY_70,
  ...ID_TO_PAGE_MAP_WOOFZ_NPDAY_75,
  ...ID_TO_PAGE_MAP_WOOFZ_NPDAY_80,
  ...ID_TO_PAGE_MAP_WOOFZ_PPDAY_65,
  ...ID_TO_PAGE_MAP_WOOFZ_XMAS_65,
  ...ID_TO_PAGE_MAP_WOOFZ_XMAS_70,
  ...ID_TO_PAGE_MAP_WOOFZ_XMAS_80,
  ...ID_TO_PAGE_MAP_WOOFZ_PPDAY_70,
  ...ID_TO_PAGE_MAP_WOOFZ_PPDAY_75,
  ...ID_TO_PAGE_MAP_WOOFZ_PPDAY_80,
  ...ID_TO_PAGE_MAP_WOOFZ_OFFER1_65,
  ...ID_TO_PAGE_MAP_WOOFZ_OFFER1_70,
  ...ID_TO_PAGE_MAP_WOOFZ_OFFER1_75,
  ...ID_TO_PAGE_MAP_WOOFZ_OFFER1_80,
  ...ID_TO_PAGE_MAP_WOOFZ_OFFER2_70,
  ...ID_TO_PAGE_MAP_WOOFZ_OFFER2_75,
  ...ID_TO_PAGE_MAP_WOOFZ_NRDAY_65,
  ...ID_TO_PAGE_MAP_WOOFZ_NRDAY_70,
  ...ID_TO_PAGE_MAP_WOOFZ_NRDAY_75,
  ...ID_TO_PAGE_MAP_WOOFZ_NRDAY_80,
  ...ID_TO_PAGE_MAP_WOOFZ_PUP,
  ...ID_TO_PAGE_MAP_WOOFZ_WA1,
  ...ID_TO_PAGE_MAP_WOOFZ_RT,
  ...ID_TO_PAGE_MAP_WOOFZ_NDD,
  ...ID_TO_PAGE_MAP_WOOFZ_NDD_65,
  ...ID_TO_PAGE_MAP_WOOFZ_NDD_70,
  ...ID_TO_PAGE_MAP_WOOFZ_NDD_75,
  ...ID_TO_PAGE_MAP_WOOFZ_NDD_80,
  ...ID_TO_PAGE_MAP_WOOFZ_PUP_BL,
  ...ID_TO_PAGE_MAP_WOOFZ_INVX,
  ...ID_TO_PAGE_MAP_WOOFZ_K9,
  ...ID_TO_PAGE_MAP_WOOFZ_VDAY_65,
  ...ID_TO_PAGE_MAP_WOOFZ_VDAY_70,
  ...ID_TO_PAGE_MAP_WOOFZ_VDAY_75,
  ...ID_TO_PAGE_MAP_WOOFZ_VDAY_80,
  ...ID_TO_PAGE_MAP_WOOFZ_HLWN_65,
  ...ID_TO_PAGE_MAP_WOOFZ_HLWN_70,
  ...ID_TO_PAGE_MAP_WOOFZ_HLWN_75,
  ...ID_TO_PAGE_MAP_WOOFZ_HLWN_80,
  ...ID_TO_PAGE_MAP_WOOFZ_SUB_CNLD_70,
  ...ID_TO_PAGE_MAP_WOOFZ_K9_BL,
  ...ID_TO_PAGE_MAP_WOOFZ_K9_DRSL,
  ...ID_TO_PAGE_MAP_WOOFZ_WOOFY,
  ...ID_TO_PAGE_MAP_WOOFZ_PUP_WT,
  ...ID_TO_PAGE_MAP_WOOFZ_PUP_DRSL,
  ...ID_TO_PAGE_MAP_WOOFZ_COACHING,
  ...ID_TO_PAGE_MAP_WOOFZ_SMD,
  ...ID_TO_PAGE_MAP_WOOFZ_SMD_BL,
  ...ID_TO_PAGE_MAP_WOOFZ_PAW_NUP,
  ...ID_TO_PAGE_MAP_WOOFZ22V4_BG,
  ...ID_TO_PAGE_MAP_WOOFZ_PT1_BG,
  ...ID_TO_PAGE_MAP_WOOFZ_K9_BL_BG,
}
